var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInstagramVerified = function SvgInstagramVerified(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3897F0",
    d: "M2,4.46701501 L2,2 L4.90331577,2 L6.15305447,1.54987134e-12 L8.34740172,1.37118034 L10.6730555,0.236883215 L11.532985,2 L14,2 L14,4.90331577 L16,6.15305447 L14.6288197,8.34740172 L15.7631168,10.6730555 L14,11.532985 L14,14 L11.0966842,14 L9.84694553,16 L7.65259828,14.6288197 L5.32694453,15.7631168 L4.46701501,14 L2,14 L2,11.0966842 L1.94599892e-12,9.84694553 L1.37118034,7.65259828 L0.236883215,5.32694453 L2,4.46701501 Z M10.7982312,5 L7.1502211,8.61693592 L5.20176884,6.68508077 L4,7.87661282 L7.1502211,11 L12,6.19153204 L10.7982312,5 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagramVerified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/InstagramVerified.c20e8f50.svg";
export { ForwardRef as ReactComponent };